export const getTopInset = (target: HTMLElement) => {
  const targetRect = target.getBoundingClientRect();

  const measurements = Array.from(
    document.querySelectorAll<HTMLElement>('[data-site-header]'),
    element => {
      const rect = element.getBoundingClientRect();
      const position = getComputedStyle(element).position;
      const overlapsTarget = rect.left < targetRect.right && rect.right > targetRect.left;
      const included = (position === 'fixed' || position === 'sticky') && overlapsTarget;

      return { element, rect, position, overlapsTarget, included };
    },
  );

  return Math.max(
    0,
    ...measurements.filter(({ included }) => included).map(({ rect }) => Math.max(rect.bottom, 0)),
  );
};
